import { connect } from 'react-redux';

import { GetFriendsReferralInfo } from './get-friends-referral-info.component';
import { getFriendsReferralInfo } from '../friends-referral-store';

import { IGetFriendsReferralStoreProps } from './get-friends-referral-info.types';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State): IGetFriendsReferralStoreProps => ({
    userId: state.login.loginSession?.UbisoftConnectProfile.user.userId!,
    appId: state.config.applicationId,
    ticket: state.login.loginSession?.UbisoftConnectTicket!,
    sessionId: state.login.loginSession?.sessionId!,
    env: state.config.envName
});

const mapDispatchToProps = { getFriendsReferralInfo };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GetFriendsReferralInfo);
